// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import { LoginResponseSuccessFragmentDoc } from './loginResponseSuccess.generated';
export const CustomerRegistrationResponseFragmentDoc = gql`
    fragment customerRegistrationResponse on CustomerRegistrationResponse {
  login {
    ...loginResponseSuccess
  }
}
    ${LoginResponseSuccessFragmentDoc}`;